<router-outlet></router-outlet>

<div class="cookie-banner-background" *ngIf="!cookie_settings">
    <div class="cookie-container">
        <p>
            Questo sito utilizza cookie tecnici “proprietari” e “di terze parti” per finalità tecniche e analitiche.
            Cliccando su "Accetta tutti", acconsenti all’uso di tutti i cookie.
            Cliccando su "Impostazioni cookie", puoi acconsentire solo a specifici tipi di cookie.
            Per saperne di più sui cookie e su come gestirli, consulta
            <a href="https://www.iubenda.com/privacy-policy/gdpr/67655323/cookie-policy">la cookie policy</a>.
        </p>
        <button class="btn btn-primary" (click)="acceptAllCookie()">ACCETTA TUTTI</button>
        <button class="btn btn-outline-secondary ml-2" (click)="openCookieComponent()">IMPOSTAZIONI COOKIE</button>
    </div>
</div>